/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as TipsRouteImport } from './routes/tips'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateRoute = DonateRouteImport.update({
  id: '/donate',
  path: '/donate',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const TipsRoute = TipsRouteImport.update({
  id: '/tips',
  path: '/tips',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/donate': typeof DonateRoute
  '/products': typeof ProductsRoute
  '/projects': typeof ProjectsRoute
  '/tips': typeof TipsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/donate': typeof DonateRoute
  '/products': typeof ProductsRoute
  '/projects': typeof ProjectsRoute
  '/tips': typeof TipsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/donate': typeof DonateRoute
  '/products': typeof ProductsRoute
  '/projects': typeof ProjectsRoute
  '/tips': typeof TipsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/about'
    | '/contact'
    | '/donate'
    | '/products'
    | '/projects'
    | '/tips'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/about'
    | '/contact'
    | '/donate'
    | '/products'
    | '/projects'
    | '/tips'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/about'
    | '/contact'
    | '/donate'
    | '/products'
    | '/projects'
    | '/tips'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  DonateRoute: typeof DonateRoute
  ProductsRoute: typeof ProductsRoute
  ProjectsRoute: typeof ProjectsRoute
  TipsRoute: typeof TipsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate': {
      id: '/donate'
      path: '/donate'
      fullPath: '/donate'
      preLoaderRoute: typeof DonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tips': {
      id: '/tips'
      path: '/tips'
      fullPath: '/tips'
      preLoaderRoute: typeof TipsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  DonateRoute: DonateRoute,
  ProductsRoute: ProductsRoute,
  ProjectsRoute: ProjectsRoute,
  TipsRoute: TipsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
